<template>
    <v-app id="inspire"  class="background-thanks" :style="this.$vuetify.breakpoint.xs ? `background-image: url(${background}); background-position: right !important;` : `background-image: url(${background});`">

    <div style="display: flex; justify-content: space-around" class=" mb-1">
    </div>

    <v-row align="center" justify="center" style="margin: 0px;">


        <v-col sm="8" md="4">

        <!-- <v-card class="elevation-4" > -->
            <v-card-text class="mb-0" style="display: flex; justify-content: space-around; margin-top:0px;">
                <img  :height="this.$vuetify.breakpoint.xs ? 130 : 180" class="image-logo2" src="@/assets/img/logo-light.png"> 
            </v-card-text>
             <div style="display: flex; justify-content: space-around;" >
                <h1 class="header-1" style="margin-top:45px;color:#000000;font-family: Arial, sans-serif;">Thank you!</h1>
            </div>
            <v-card-text class="mb-0 mt-10">
                <p class="p-1 text-h5" style="color:#000000!important"><strong>If you have not received any email within 24 hours, please contact us at steve@streetsmartinvestmentsllc.com</strong></p>
            </v-card-text>

           
        <!-- </v-card> -->
        </v-col>
    </v-row>
</v-app>
</template>

<script>
// import image from "./assets/profile.png"
import axios from "axios";
import Utility from "@/components/common/functions.js";
export default {
props: {
    source: String,
},

data () {
return {
    email : '',
    password : '',
    showPassword : false,
    dialog: false,
    background: require('@/assets/img/4837-ScpRUztNoKFlWxVB.webp'),

}
},
beforeCreate: function () {
    // if (localStorage.getItem('token')) {
    //     this.$router.push('/dashboard')
    // }
},
methods: {


},

}
</script>

<style scoped>
   html {
  overflow: hidden !important;
}

</style>
<style>
.separator {
    display: flex;
    align-items: center;
    text-align: center;
}
.separator::before, .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid rgba(0,0,0,.6);
}
.separator::before {
    margin-right: .25em;
}
.separator::after {
    margin-left: .25em;
}
.background-thanks{
    background-size: cover !important;
    background-repeat: no-repeat!important;
    background-position: center top!important;
    background-attachment: scroll!important;
    min-height: 100%!important;
}
.header-1{
    color: #150F24;
    font-family: 'Source Sans Pro';
    font-weight: 700;
    font-style: normal;
    text-align: center;
    padding: 10px;
    margin-top: 0px;
    font-size: 50px;
}
.p-1{
color: #272343;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    text-align: center;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 1.2rem;
}
.icon-check{
    font-size: 68px!important;
    color: rgb(0, 184, 129)!important;
}
</style>
